<form [formGroup]="formGroup" *ngIf="states.length">
  <div class="row">
    <div class="col-4">
      <mat-form-field floatLabel="always">
        <mat-label>State</mat-label>
        <mat-select formControlName="state" required placeholder="Select a State">
          <mat-option *ngFor="let state of states" [value]="state">
            {{ state }}
          </mat-option>
        </mat-select>
        <mat-icon *ngIf="validStateCity" matSuffix>check</mat-icon>
        <mat-error *ngIf="formGroup.get('state').hasError('required')">Field required</mat-error>
        <mat-error *ngIf="formGroup.get('state').hasError('notFound')">No result for this combination</mat-error>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field floatLabel="always">
        <mat-label>City</mat-label>
        <input
          matInput
          formControlName="city"
          required
          style="text-transform: uppercase"
          pattern="[a-zA-Z0-9]+"
        />
        <mat-icon *ngIf="validStateCity" matSuffix>check</mat-icon>
        <mat-error *ngIf="formGroup.get('city').hasError('required')">Field required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-2">
      <button
        class="aux-button"
        [disabled]="checking || formGroup.get('state').hasError('required') || formGroup.get('city').hasError('required')"
        mat-stroked-button
        (click)="listZipCds()">{{ checking ? 'Loading...' : 'Find ZIP' }}
      </button>
    </div>
  </div>
  <div class="col-12">
    <mat-form-field floatLabel="always">
    <mat-label>Postal code{{ postalCodes.length > 1 ? 's' : '' }}</mat-label>
    <mat-select formControlName="zipCd" required [placeholder]="postalCodes.length > 1 ? 'Select a Postal Code' : null">
      <mat-option *ngFor="let postalCd of postalCodes" [value]="postalCd">
        {{ postalCd }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="formGroup.get('zipCd').hasError('required')">Field required</mat-error>
  </mat-form-field>
  </div>
</form>
